import gql from 'graphql-tag'
import client from '@stores/apollo'

interface Payload {
  viewer: {
    company: {
      mapping: {
        spacesTagsImportTemplateFile: string
      }
    }
  }
}

export default async function spacesTemplate(): Promise<string> {
  try {
    const { data } = await client.gql.query<Payload>({ query })
    return data.viewer.company.mapping.spacesTagsImportTemplateFile
  } catch (e) {
    console.log(e)
    return ''
  }
}

const query = gql`
  query SpacesTagsImportTemplate {
    viewer {
      company {
        mapping {
          spacesTagsImportTemplateFile
        }
      }
    }
  }
`
